import { render } from "./Program.vue?vue&type=template&id=7a8c8bf6"
import script from "./Program.vue?vue&type=script&lang=js"
export * from "./Program.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\apps\\appKonferenceStudioW\\v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__